export default __webpack_public_path__ + "img/7312d8163716f582b5e3d4e3733d7a23.svg";